<div class="flight-category" [ngClass]="cssClass" [matTooltip]="tooltip">
  <div class="flight-category__label">{{label}}</div>
</div>
